'use client'

import React from 'react'

interface Props {
    children: React.ReactNode
    sidebar: React.ReactNode
    sidebarPosition?: 'left' | 'right'
}

const SidebarScrollWrapper = ({ children, sidebar, sidebarPosition = 'right' }: Props) => {
    return (
        <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 w-full items-start">
            {sidebarPosition === 'left' && (
                <div className="w-full lg:w-64 xl:w-72 flex-shrink-0 sticky top-24 order-2 lg:order-1">{sidebar}</div>
            )}
            <div className="flex-1 min-w-0 w-full order-1 lg:order-2">
                {children}
            </div>
            {sidebarPosition === 'right' && (
                <div className="w-full lg:w-64 xl:w-72 flex-shrink-0 sticky top-24 order-2 lg:order-3">{sidebar}</div>
            )}
        </div>
    )
}

export default SidebarScrollWrapper